module.exports = __webpack_public_path__ + "static/media/(V)_MG_5274_-_Cia_Termal_-_Moda_Feminina.ba0a1363.jpg";